import React, {
  forwardRef,
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
  useImperativeHandle,
} from "react";
import AgGridTable from "../utilities/AgGridTable";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import {
  CustomerEditorComponent,
  CriteriaEditorComponent,
  OrderCategoryEditorComponent,
  PriceGroupEditorComponent,
  ProductEditorComponent,
  ShowroomEditorComponent,
  VendorEditorComponent,
  OrderTypeEditorComponent,
  PaymentTermEditorComponent,
  DateTypeEditorComponent,
} from "./SelectEditorComponent";
import NumericCellEditorComponent from "./NumericCellEditorComponent";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "./DatepickerEditorComponent";
import moment from "moment";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { Switch, useMediaQuery, useTheme } from "@mui/material";
import DialogBox from "../utilities/DialogBox";
import activeCellEditor from "./ActiveCellEditor";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Paper,
} from "@mui/material";
import { toast } from "react-toastify";
import Draggable from "react-draggable";
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

const DiscountGrid = forwardRef((props, ref) => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const perPage = 10;
  const [error, setError] = useState("");
  const [vendorId, setVendorId] = useState();
  const [customerId, setCustomerId] = useState();
  const gridRef = useRef(null);
  const [saveBtnDisable, setSaveBtnDisable] = useState(true);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [priView, setPriView] = useState([]);
  const [priUpdate, setPriUpdate] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [priRequest, setPriRequest] = useState([]);
  const [priApprove, setPriApprove] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [discountType, setDiscountType] = useState(props.discountType);
  const [editId, setEditId] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [addRowData, setAddRowData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [active, setActive] = useState(false);
  const [activeOpen, setActiveOpen] = useState(false);
  const [year, setYear] = useState(props.year);
  const [rangeList, setRangeList] = useState([]);
  const [handleList, setHandleList] = useState([]);
  const [discountStatus, setDiscountStatus] = useState(props.discountStatus);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [rowToDelete, setRowToDelete] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const [customerOptions, setCustomerOptions] = useState([]);
  const [allCustomerOptions, setAllCustomerOptions] = useState([]);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [showroomMap, setShowroomMap] = useState({});
  const [allShowrooms, setAllShowrooms] = useState([]);
  const showDiscountPercent = (props) => {
    return <p>{props?.value && <>{Number(props?.value).toFixed(3)}%</>}</p>;
  };
  const showOverlay = () => {
    gridRef.current?.api?.showLoadingOverlay();
  };

  const hideOverlay = () => {
    gridRef.current?.api?.hideOverlay();
  };
  const isMobileRef = useRef(isMobile);
  useEffect(() => {
    isMobileRef.current = isMobile;
  }, [isMobile]);

 
  const showStatusIcon = (props, type) => {
    let statusicon = "";
    let statusColor = "";
    const isLight = theme.palette.mode === "light";

    if (props?.data?.approvalStatus === "NEW") {
      statusColor = isLight ? "#333" : "#fff";
      statusicon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: statusColor }}>
            material-solid:fiber_new
          </FuseSvgIcon>
          {props?.value}{" "}
          {(props?.data?.enablePromoDisc ||
            props?.data?.enableVendorPromoDisc) && (
            <FuseSvgIcon className="ml-5" size={16}>
              material-solid:local_offer
            </FuseSvgIcon>
          )}
        </>
      );
    }
    if (props?.data?.approvalStatus === "PENDING_APPROVAL") {
      statusColor = isLight ? "#c49000" : "yellow";
      statusicon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: statusColor }}>
            material-solid:error
          </FuseSvgIcon>
          {props?.value}{" "}
          {(props?.data?.enablePromoDisc ||
            props?.data?.enableVendorPromoDisc) && (
            <FuseSvgIcon className="ml-5" size={16}>
              material-solid:local_offer
            </FuseSvgIcon>
          )}
        </>
      );
    }
    if (props?.data?.approvalStatus === "APPROVED") {
      statusColor = "#53e153";
      statusicon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: statusColor }}>
            material-solid:check_circle
          </FuseSvgIcon>
          {props?.value}{" "}
          {(props?.data?.enablePromoDisc ||
            props?.data?.enableVendorPromoDisc) && (
            <FuseSvgIcon className="ml-5" size={16}>
              material-solid:local_offer
            </FuseSvgIcon>
          )}
        </>
      );
    }
    if (props?.data?.approvalStatus === "REJECTED") {
      statusColor = "#e35151";
      statusicon = (
        <>
          <FuseSvgIcon size={18} style={{ fill: statusColor }}>
            material-solid:cancel
          </FuseSvgIcon>
          {props?.value}{" "}
          {(props?.data?.enablePromoDisc ||
            props?.data?.enableVendorPromoDisc) && (
            <FuseSvgIcon className="ml-5" size={16}>
              material-solid:local_offer
            </FuseSvgIcon>
          )}
        </>
      );
    }
    return (
      <p className="flex items-center">
        {((props.column.colId === "custName" && type === "Customer") ||
          (props.column.colId === "vendorName" && type === "Vendor")) &&
        props?.value
          ? statusicon
          : props?.value}{" "}
      </p>
    );
  };

  const handleDateFormat = (props) => {
    return props?.value && moment(props?.value).format("DD-MM-YYYY");
  };

  function IconComponent(props) {
    let bool = props?.data?.active;
    return (
      <>
        <Switch
          size="small"
          checked={bool}
          onClick={() => {
            handleSwitchClick(bool);
          }}
        />
      </>
    );
  }
  var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      var dateAsString = cellValue;
      //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
      const date = new Date(dateAsString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      if (formattedDate == null) return -1;
      var dateParts = formattedDate.split("/");
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    maxValidYear: new Date().getFullYear(),
  };
  const handleSwitchClick = (bool) => {
    setActive(bool);
    setActiveOpen(true);
  };
  const loadAllShowrooms = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showrooms}/search/findByActiveTrue`;

    const res = await OAuthService.getList(url);

    const result =
      res?.data?._embedded?.showrooms?.map((s) => ({
        id: s.id,
        label: `${s.id}-${s.name}`,
        name: s.name,
      })) || [];

    setAllShowrooms(result);
  };
  useEffect(() => {
    loadAllShowrooms();
  }, []);
  const loadCustomerShowrooms = async (customerId) => {
    if (!customerId) return [];

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/${customerId}/showrooms?size=1000`;

    const res = await OAuthService.getList(url);

    return (
      res?.data?._embedded?.showrooms?.map((s) => ({
        id: s.id,
        label: `${s.id}-${s.name}`,
        name: s.name,
      })) || []
    );
  };

  const buildShowroomMap = async (customers = []) => {
    const map = {};

    await Promise.all(
      customers.map(async (c) => {
        const list = await loadCustomerShowrooms(c.custNum);
        map[c.custNum] = list;
      }),
    );

    setShowroomMap(map);
  };
  useEffect(() => {
    if (rowData?.length) {
      const uniqueCustomers = [
        ...new Map(
          rowData.filter((r) => r.custNum).map((r) => [r.custNum, r]),
        ).values(),
      ];

      buildShowroomMap(uniqueCustomers);
    }
  }, [rowData]);
  useEffect(() => {
    const getCustomersList = async () => {
      const token =
        localStorage &&
        localStorage.getItem("token") &&
        jwtDecode(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
      let result = [];
      try {
        if (
          token.scope.includes("ROLE_IAM") &&
          !(
            token?.scope?.includes("ROLE_ADMIN") ||
            token?.scope?.includes("ROLE_SOPDIR")
          )
        ) {
          const discountURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
          const partners = await OAuthService.getList(
            discountURL + `/getcompaniesbyiamterritory`,
          );
          result = partners?.data
            ?.filter((data) => data.active && data.customerType === "REGULAR")
            ?.map((value) => ({
              label: `${value.id} - ${value.shortKey} - ${value.countryCode}`,
              name: value.name,
              id: value.id,
            }));
        } else {
          const partners = await OAuthService.getList(
            url + `/search/findByCustomerType?customerType=REGULAR`,
          );
          result = partners?.data?._embedded?.companies?.map((value) => ({
            label: `${value.id} - ${value.shortKey} - ${value.countryCode}`,
            name: value.name,
            id: value.id,
          }));
        }
      } catch (err) {
        console.error("Error loading customers", err);
      }
      setCustomerOptions(result || []);
    };

    getCustomersList();
  }, []);
  const getOrderCategoryList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;
    try {
      const orderCategories = await OAuthService.getList(url + `?size=1000`);
      const result = orderCategories?.data?._embedded?.orderCategories.map(
        (value) => {
          return {
            value: value.name,
            label: value.name,
            name: value.displayName,
          };
        },
      );
      setOrderCategoryOptions(result);
    } catch (error) {}
  };
  useEffect(() => {
    getOrderCategoryList();
  }, []);

  useEffect(() => {
    const getAllCustomersList = async () => {
      const token =
        localStorage &&
        localStorage.getItem("token") &&
        jwtDecode(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
      let result = [];
      try {
        const partners = await OAuthService.getList(
          url + `/search/findByCustomerType?customerType=REGULAR`,
        );
        result = partners?.data?._embedded?.companies?.map((value) => ({
          label: `${value.id} - ${value.shortKey} - ${value.countryCode}`,
          name: value.name,
          id: value.id,
        }));
      } catch (err) {
        console.error("Error loading customers", err);
      }
      setAllCustomerOptions(result || []);
    };

    getAllCustomersList();
  }, []);
  //   useEffect(() => {
  //   console.log("Theme changed", theme.palette.mode);

  //  gridRef.current?.api?.refreshCells({
  //   force: true,
  //   columns: ["custName"],
  //   suppressFlash: true,
  // });
  // }, [theme.palette.mode]);
  useEffect(() => {
    if (gridRef.current) {
      gridRef?.current?.api?.refreshCells({ force: true });
      gridRef?.current?.api?.redrawRows();
    }
  }, [theme.palette.mode]);
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "custNum",
      hide: "true",
      editable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      field: "custVendRefNum",
      enableRowGroup: true,
      type: "editableColumn",
      headerName: "Cust Vend Ref Num*",
      cellEditor: NumericCellEditorComponent,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      minWidth: "54",
    },
    {
      field: "orderCategoryName",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: OrderCategoryEditorComponent,
      headerName: "Order Category*",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      minWidth: "50",
      cellEditorParams: {
        orderCategoryOptions,
      },
    },
    {
      field: "validFrom",
      enableRowGroup: true,
      type: "editableColumn",
      headerName: "Valid From*",
      cellEditor: DateFromEditorComponent,
      filter: "agDateColumnFilter",
      filterParams,
      cellRenderer: handleDateFormat,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      minWidth: "80",
    },
    {
      field: "validTo",
      enableRowGroup: true,
      type: "editableColumn",
      headerName: "Valid To*",
      cellEditor: DateToEditorComponent,
      filter: "agDateColumnFilter",
      filterParams,
      cellRenderer: handleDateFormat,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      minWidth: "80",
    },
    {
      field: "criteria",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: CriteriaEditorComponent,
      minWidth: "75",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      valueGetter: ({ data }) => {
        return (data?.enablePromoDisc || data?.enableVendorPromoDisc) &&
          data?.criteria === null
          ? "ALL"
          : data?.criteria;
      },
    },
    {
      field: "productIds",
      hide: "true",
      editable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      field: "productNames",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: ProductEditorComponent,
      headerName: "Sub-Criteria",
      minWidth: "85",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
    },
    {
      field: "dateType",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: DateTypeEditorComponent,
      headerName: "Stage",
      minWidth: "85",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
    },
    {
      field: "custName",
      enableRowGroup: true,
      headerName: "Partner*",
      type: "editableColumn",
      width: 130,
      minWidth: "130",
      cellEditor: CustomerEditorComponent,
      cellEditorParams: () => ({
        customerOptions,
      }),
      pinned: isMobile ? false : "left",
      valueGetter: (params) => {
        const allCustomerOptions = params.context?.allCustomerOptions || [];

        const customer = allCustomerOptions.find(
          (c) => c.id === params.data?.custNum,
        );

        return customer ? customer.label : params.data?.custNum;
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      cellRenderer: (params) => showStatusIcon(params, discountType),
    },
    {
      field: "vendorNum",
      hide: "true",
      editable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      field: "vendorName",
      minWidth: "70",
      enableRowGroup: true,
      cellEditor: VendorEditorComponent,
      pinned: isMobile ? false : "left",
      type: "editableColumn",
      headerName: "Product*",
      cellRenderer: (params) => showStatusIcon(params, discountType),
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
    },
    {
      field: "fromQty",
      width: 50,
      minWidth: 35,
      pinned: isMobile ? false : "left",
      cellEditor: NumericCellEditorComponent,
      headerName: "From Qty*",
      type: "editableColumn",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      minWidth: "54",
    },
    {
      field: "toQty",
      width: 50,
      minWidth: 35,
      pinned: isMobile ? false : "left",
      cellEditor: NumericCellEditorComponent,
      type: "editableColumn",
      headerName: "To Qty*",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      minWidth: "54",
    },
    {
      field: "showroomNum",
      hide: "true",
      editable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      field: "showroomName",
      headerName: "Showroom",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: ShowroomEditorComponent,
      cellEditorParams: (params) => ({
        showroomMap,
        allShowrooms,
      }),
      minWidth: "90",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
    },
    {
      field: "slabNum",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: NumericCellEditorComponent,
      headerName: "Slab Num*",
      minWidth: "35",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
    },
    {
      field: "priceGroupNames",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: PriceGroupEditorComponent,
      editable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
      hide: true,
      minWidth: "54",
    },
    {
      field: "orderType",
      enableRowGroup: true,
      type: "editableColumn",
      cellEditor: OrderTypeEditorComponent,
      minWidth: "40",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : null,
    },
    // { field: 'enablePromoDisc', enableRowGroup: true},
    {
      field: "wg1CustStdDiscount",
      headerName: "WG1 STD Disc*",
      type: "editableColumn",
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      headerClass: "WG1discount-header",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "hsl(40, 86%, 45%)", color: "#fff" },
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "wg1CustSpclDiscount",
      type: "editableColumn",
      headerName: "WG1 SPCL Disc*",
      //enableRowGroup: true,
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      headerClass: "WG1discount-header",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellEditor: NumericCellEditorComponent,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "hsl(40, 86%, 45%)", color: "#fff" },
    },
    {
      field: "wg1PromoDiscount",
      type: "editableColumn",
      headerName: "WG1 PROMO Disc*",
      enableRowGroup: true,
      cellEditor: NumericCellEditorComponent,
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "hsl(40, 72%, 34%)", color: "#fff" },
      headerClass: "WG1Promodiscount-header",
    },
    {
      field: "wg1CustCumulativeDiscount",
      type: "editableColumn",
      headerName: "WG1 Cumulative Disc",
      //enableRowGroup: true,
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      headerClass: "WG1discount-header",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "hsl(40, 86%, 45%)", color: "#fff" },
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "wg2CustStdDiscount",
      type: "editableColumn",
      enableRowGroup: true,
      headerName: "WG2 STD Disc*",
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerClass: "WG2discount-header",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#2f765f", color: "#fff" },
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "wg2CustSpclDiscount",
      type: "editableColumn",
      enableRowGroup: true,
      headerName: "WG2 SPCL Disc*",
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerClass: "WG2discount-header",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#2f765f", color: "#fff" },
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "wg2PromoDiscount",
      type: "editableColumn",
      enableRowGroup: true,
      minWidth: "60",
      cellEditor: NumericCellEditorComponent,
      headerName: "WG2 PROMO Disc*",
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerClass: "WG2Promodiscount-header",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#114635", color: "#fff" },
    },
    {
      field: "wg2CustCumulativeDiscount",
      type: "editableColumn",
      enableRowGroup: true,
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      headerName: "WG2 Cumulative Disc",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#2f765f", color: "#fff" },
      editable: false,
      headerClass: "WG2discount-header",
      cellEditor: NumericCellEditorComponent,
    },

    {
      field: "wg1VendorStdDiscount",
      type: "editableColumn",
      headerName: "WG1 STD Disc*",
      minWidth: "60",
      cellRenderer: showDiscountPercent,
      headerClass: "WG1discount-header",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      cellEditor: NumericCellEditorComponent,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "hsl(40, 86%, 45%)", color: "#fff" },
    },
    {
      field: "wg1VendorSpclDiscount",
      type: "editableColumn",
      headerName: "WG1 SPCL Disc*",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      minWidth: "60",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)  ", color: "#fff" }
          : { backgroundColor: "hsl(40, 86%, 45%)", color: "#fff" },
      cellRenderer: showDiscountPercent,
      headerClass: "WG1discount-header",
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "wg1VendorPromoDiscount",
      type: "editableColumn",
      headerName: "WG1 PROMO Disc*",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      minWidth: "60",
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)  ", color: "#fff" }
          : { backgroundColor: "hsl(40, 72%, 34%)", color: "#fff" },
      cellRenderer: showDiscountPercent,
      headerClass: "WG1Promodiscount-header",
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "wg1VendorCumulativeDiscount",
      type: "editableColumn",
      headerName: "WG1 Cumulative Disc",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      minWidth: "60",
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64) ", color: "#fff" }
          : { backgroundColor: "hsl(40, 86%, 45%)", color: "#fff" },
      cellRenderer: showDiscountPercent,
      headerClass: "WG1discount-header",
    },
    {
      field: "wg2VendorStdDiscount",
      type: "editableColumn",
      minWidth: "60",
      cellEditor: NumericCellEditorComponent,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#2f765f", color: "#fff" },
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerName: "WG2 STD Disc*",
      headerClass: "WG2discount-header",
    },
    {
      field: "wg2VendorSpclDiscount",
      type: "editableColumn",
      minWidth: "60",
      cellEditor: NumericCellEditorComponent,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#2f765f", color: "#fff" },
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerName: "WG2 SPCL Disc*",
      headerClass: "WG2discount-header",
    },
    {
      field: "wg2VendorPromoDiscount",
      type: "editableColumn",
      minWidth: "60",
      cellEditor: NumericCellEditorComponent,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)", color: "#fff" }
          : { backgroundColor: "#114635", color: "#fff" },
      cellRenderer: showDiscountPercent,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerName: "WG2 PROMO Disc*",
      headerClass: "WG2Promodiscount-header",
    },
    {
      field: "wg2VendorCumulativeDiscount",
      type: "editableColumn",
      minWidth: "60",
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64) ", color: "#fff" }
          : { backgroundColor: "#2f765f", color: "#fff" },
      cellRenderer: showDiscountPercent,
      headerName: "WG2 Cumulative Disc",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      headerClass: "WG2discount-header",
    },
    // { field: 'paymentTerm', type: 'editableColumn',  minWidth: '50', cellEditor: PaymentTermEditorComponent, cellStyle: (params) => (params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc) ? { backgroundColor: 'rgb(118 105 64)  ' } : null },
    {
      field: "active",
      type: "editableColumn",
      minWidth: "54",
      cellRenderer: IconComponent,
      cellStyle: (params) => {
        if (params?.data?.approvalStatus === "NEW") {
          return {
            pointerEvents: "none",
          };
        }

        if (
          params?.data?.enablePromoDisc ||
          params?.data?.enableVendorPromoDisc
        ) {
          return { backgroundColor: "rgb(118 105 64)", color: "#fff" };
        }

        return null;
      },
      cellEditor: activeCellEditor,
      editable: (params) => params?.data?.approvalStatus !== "NEW",
    },
    {
      field: "createdByUser",
      minWidth: "65",
      headerName: "Created By",
      type: "editableColumn",
      enableRowGroup: true,
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)   ", color: "#fff" }
          : null,
    },
    {
      field: "requestedBy",
      minWidth: "65",
      headerName: "Requested By",
      type: "editableColumn",
      enableRowGroup: true,
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)   ", color: "#fff" }
          : null,
    },
    {
      field: "requestedDate",
      minWidth: "65",
      headerName: "Requested Date",
      type: "editableColumn",
      enableRowGroup: true,
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)   ", color: "#fff" }
          : null,
      cellRenderer: handleDateFormat,
      filter: "agDateColumnFilter",
      filterParams,
    },
    {
      field: "approvedDttm",
      minWidth: "65",
      headerName: "Approved Date",
      type: "editableColumn",
      enableRowGroup: true,
      editable: false,
      cellStyle: (params) =>
        params?.data?.enablePromoDisc || params?.data?.enableVendorPromoDisc
          ? { backgroundColor: "rgb(118 105 64)   ", color: "#fff" }
          : null,
      cellRenderer: handleDateFormat,
      filter: "agDateColumnFilter",
      filterParams,
    },
  ]);
 const PINNABLE_COLS = ["custName", "vendorName", "fromQty", "toQty"];
  const originalFieldOrder = useRef(columnDefs.map((c) => c.field));
  const discountTypeRef = useRef(discountType);
  useEffect(() => {
    discountTypeRef.current = discountType;
  }, [discountType]);

  const getLeadingCols = (type) =>
    type === "Customer"
      ? ["custName", "vendorName", "fromQty", "toQty"]
      : ["vendorName", "fromQty", "toQty"];

  const syncPinnedColumns = (type) => {
    const mobile = isMobileRef.current;
    const leading = getLeadingCols(type);

    const getPinned = (colId) => {
      if (mobile) return null; // never pin on mobile
      if (colId === "custName") return type === "Customer" ? "left" : null;
      return "left";
    };

    const api = gridRef.current?.columnApi;
    if (api) {
      if (mobile) {
        const current = (
          api.getAllGridColumns?.() ||
          api.getColumns?.() ||
          []
        ).map((c) => c.getColId());
        const rest = current.filter((id) => !leading.includes(id));

        api.applyColumnState({
          state: [...leading, ...rest].map((colId) =>
            PINNABLE_COLS.includes(colId) ? { colId, pinned: null } : { colId },
          ),
          applyOrder: true,
        });
      } else {
        api.applyColumnState({
          state: PINNABLE_COLS.map((colId) => ({
            colId,
            pinned: getPinned(colId),
          })),
        });
      }
    }

    setColumnDefs((prev) => {
      const mapped = prev.map((col) =>
        PINNABLE_COLS.includes(col.field)
          ? { ...col, pinned: getPinned(col.field) }
          : col,
      );

      if (mobile) {
        const head = leading
          .map((f) => mapped.find((c) => c.field === f))
          .filter(Boolean);
        const tail = mapped.filter((c) => !leading.includes(c.field));
        return [...head, ...tail];
      }

      const idx = (f) => originalFieldOrder.current.indexOf(f);
      return [...mapped].sort((a, b) => idx(a.field) - idx(b.field));
    });
  };
  const onBtExport = useCallback(() => {
    const params = {
      fileName: "DiscountMaster.xlsx",
      sheetName: "Discount Master",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onResetColumnState = () => {
    const updatedColDef = [...columnDefs];
    let colcustindexAction = updatedColDef?.findIndex(
      (column) => column.field === "custName",
    );
    let colcustRefindexAction = updatedColDef?.findIndex(
      (column) => column.field === "custVendRefNum",
    );
    updatedColDef[colcustindexAction].cellRenderer = (params) =>
      showStatusIcon(params, discountType);
    let colvendindexAction = updatedColDef?.findIndex(
      (column) => column.field === "vendorName",
    );
    updatedColDef[colvendindexAction].cellRenderer = (params) =>
      showStatusIcon(params, discountType);
    if (discountType === "Customer") {
      updatedColDef[colcustindexAction].pinned = isMobileRef.current
        ? null
        : "left";
      updatedColDef[colcustindexAction].headerName = "Partner*";
      updatedColDef[colcustRefindexAction].headerName = "Cust Vend Ref Num*";
      gridRef?.current?.columnApi?.applyColumnState({
        state: [
          { colId: "showroomName", hide: false },
          { colId: "custName", hide: false, pinned: isMobile ? false : "left" },
          { colId: "wg1CustStdDiscount", hide: false },
          { colId: "wg1CustSpclDiscount", hide: false },
          { colId: "criteria", hide: false },
          { colId: "wg1PromoDiscount", hide: false },
          { colId: "wg1CustCumulativeDiscount", hide: false },
          { colId: "wg2CustStdDiscount", hide: false },
          { colId: "wg2CustSpclDiscount", hide: false },
          { colId: "wg2PromoDiscount", hide: false },
          { colId: "wg2CustCumulativeDiscount", hide: false },
          { colId: "custVendRefNum", hide: false },
          { colId: "wg1VendorStdDiscount", hide: true },
          { colId: "wg1VendorSpclDiscount", hide: true },
          { colId: "wg1VendorPromoDiscount", hide: true },
          { colId: "wg1VendorCumulativeDiscount", hide: true },
          { colId: "wg2VendorStdDiscount", hide: true },
          { colId: "wg2VendorSpclDiscount", hide: true },
          { colId: "wg2VendorPromoDiscount", hide: true },
          { colId: "wg2VendorCumulativeDiscount", hide: true },
        ],
      });
    } else {
      updatedColDef[colcustindexAction].pinned = null;
      updatedColDef[colcustindexAction].headerName = "Partner";
      updatedColDef[colcustRefindexAction].headerName = "Cust Vend Ref Num";
      gridRef?.current?.columnApi?.applyColumnState({
        state: [
          // { colId: 'vendorName', hide: false },
          { colId: "custName", hide: false, pinned: null },
          { colId: "wg1VendorStdDiscount", hide: false },
          { colId: "wg1VendorSpclDiscount", hide: false },
          { colId: "wg1VendorPromoDiscount", hide: false },
          { colId: "wg1VendorCumulativeDiscount", hide: false },
          { colId: "wg2VendorStdDiscount", hide: false },
          { colId: "wg2VendorSpclDiscount", hide: false },
          { colId: "wg2VendorPromoDiscount", hide: false },
          { colId: "wg2VendorCumulativeDiscount", hide: false },

          { colId: "showroomName", hide: false },
          { colId: "wg1CustStdDiscount", hide: true },
          { colId: "wg1CustSpclDiscount", hide: true },
          { colId: "custVendRefNum", hide: true },
          { colId: "wg1PromoDiscount", hide: true },
          { colId: "wg1CustCumulativeDiscount", hide: true },
          { colId: "wg2CustStdDiscount", hide: true },
          { colId: "wg2CustSpclDiscount", hide: true },
          { colId: "wg2PromoDiscount", hide: true },
          { colId: "wg2CustCumulativeDiscount", hide: true },
        ],
      });
    }
    syncPinnedColumns(discountType);
    setColumnDefs(updatedColDef);
    gridRef?.current?.api?.refreshCells();
  };

  const loadRequestRef = useRef(0);
  const loadDiscounts = async () => {
    showOverlay();
    try {
      if (
        (priView && priView.length > 0) ||
        token?.scope.includes("PRIVILEGE_VIDISC")
      ) {
        try {
          let list = [];
          const criteria = {
            discountYear: year,
            approvalStatus: discountStatus === "All" ? "" : discountStatus,
            discountType: discountType,
            vendorNum: vendorId,
            custNum: customerId,
          };
          list = await OAuthService.addData(
            url + "/getdiscountsbycriteria",
            criteria,
          );
          const vendorurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
          const vendors = [];
          const vendorList = await OAuthService.getList(
            vendorurl + `?size=1000`,
          );
          vendorList?.data?._embedded?.factoryVendors.map((value) => {
            vendors[value.id] = value.shortKey;
            return value;
          });

          const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
          const userlist = await OAuthService.getList(
            userUrl + `?sort=firstName,asc&size=1000`,
          );
          const users = [];
          userlist.data?._embedded?.users.map((data, key) => {
            data.name = data.firstName + " " + data.lastName;
            users[data.email] = data.name;
            return data;
          });
          if (list?.data) {
            let discounts = list?.data.map((discount) => {
              if (discount.enablePromoDisc || discount.enableVendorPromoDisc) {
                if (!discount.orderType) {
                  discount.orderType = "ALL";
                }
                if (!discount.criteria || discount.criteria === null) {
                  discount.criteria = "ALL";
                }
              }
              if (partnerList[discount.custNum]) {
                discount.custName = partnerList[discount.custNum];
              } else {
                discount.custName = "";
              }

              if (
                discount.priceGroupNames &&
                discount.priceGroupNames.length > 0 &&
                discount.criteria !== "ALL"
              ) {
                discount.criteria = "PRICE GROUP";
                discount.productNames = discount.priceGroupNames;
              }
              discount.createdByUser = users[discount.createdByUser]
                ? users[discount.createdByUser]
                : discount.createdByUser;
              discount.requestedBy = users[discount.requestedBy]
                ? users[discount.requestedBy]
                : discount.requestedBy;

              if (discount.products && discount.criteria !== "ALL") {
                discount.productIds = discount.products;
                if (handleList[discount.products[0]]) {
                  discount.criteria = "HANDLE";
                  discount.productNames = [handleList[discount.products[0]]];
                } else if (rangeList[discount.products[0]]) {
                  discount.criteria = "RANGE";
                  discount.productNames = [rangeList[discount.products[0]]];
                }
              }
              if (
                discount.wg1PromoDiscount === undefined ||
                discount.wg1PromoDiscount === null
              ) {
                discount.wg1PromoDiscount = 0;
              }
              if (
                discount.wg2PromoDiscount === undefined ||
                discount.wg2PromoDiscount === null
              ) {
                discount.wg2PromoDiscount = 0;
              }
              if (
                discount.wg1VendorPromoDiscount === undefined ||
                discount.wg1VendorPromoDiscount === null
              ) {
                discount.wg1VendorPromoDiscount = 0;
              }
              if (
                discount.wg2VendorPromoDiscount === undefined ||
                discount.wg2VendorPromoDiscount === null
              ) {
                discount.wg2VendorPromoDiscount = 0;
              }

              if (discount.wg1PromoDiscount || discount.wg2PromoDiscount) {
                if (discountType === "Vendor") {
                  discount.wg1VendorPromoDiscount = discount.wg1PromoDiscount;
                  discount.wg2VendorPromoDiscount = discount.wg2PromoDiscount;
                }
              }
              discount.vendorName = vendors[discount.vendorNum];
              return discount;
            });
            setRowData(discounts);
            hideOverlay();
            // toggleAutoSize(false)
          } else {
            setRowData([]);
            hideOverlay();
          }

          setError("");
        } catch (error) {
          hideOverlay();
          setError(error?.response?.data?.errorMessage || error.message);
        }
      } else {
        setError("You don't have privileges to view Discount");
      }
    } catch (error) {
      hideOverlay();
      setError(error?.response?.data?.errorMessage || error.message);
    }
    hideOverlay();
    setSelectedRows([]);
    setSuccessMsg("");
  };

  useEffect(() => {
    if (props) {
      setDiscountType(props.discountType);
      setDiscountStatus(props.discountStatus);
      setYear(props.year);
      setVendorId(props.vendorId);
      setCustomerId(props.customerId);
    }
  }, [props]);
  useEffect(() => {
    if (!initialLoaded) return; // avoid first run
    loadDiscounts();
  }, [year, discountStatus, discountType, vendorId, customerId, initialLoaded]);
  // useEffect(() => {
  //     loadDiscounts();
  // }, [year, discountStatus, discountType, partnerList, rangeList, handleList])
  useEffect(() => {
    if (!customerOptions.length) return;
    setColumnDefs((prev) =>
      prev.map((col) => {
        if (col.field === "custName") {
          return { ...col, cellEditorParams: () => ({ customerOptions }) };
        }
        return col;
      }),
    );
  }, [customerOptions]);
  useEffect(() => {
    if (gridApi && customerOptions?.length) {
      gridApi.refreshCells({ force: true });
    }
  }, [customerOptions]);
  useEffect(() => {
    setColumnDefs((prev) =>
      prev.map((col) => {
        if (col.field === "custName" || col.field === "vendorName") {
          return {
            ...col,
            cellRenderer: (params) =>
              showStatusIcon(params, discountType, theme.palette.mode),
          };
        }
        return col;
      }),
    );

    gridRef.current?.api?.refreshCells({ force: true });
  }, [theme.palette.mode, discountType]);
  const onGridReady = useCallback(
    (params) => {
      props.gridRef(gridRef);
      setGridApi(params.api);

      const updatedColDef = [...columnDefs];
      let colcustindexAction = updatedColDef?.findIndex(
        (column) => column.field === "custName",
      );
      let colcustRefindexAction = updatedColDef?.findIndex(
        (column) => column.field === "custVendRefNum",
      );
      updatedColDef[colcustindexAction].cellRenderer = (params) =>
        showStatusIcon(params, discountType);
      let colvendindexAction = updatedColDef?.findIndex(
        (column) => column.field === "vendorName",
      );
      updatedColDef[colvendindexAction].cellRenderer = (params) =>
        showStatusIcon(params, discountType);
      if (discountType === "Customer") {
        updatedColDef[colcustindexAction].pinned = isMobileRef.current
          ? null
          : "left";
        updatedColDef[colcustindexAction].headerName = "Partner*";
        updatedColDef[colcustRefindexAction].headerName = "Cust Vend Ref Num*";
        gridRef.current.columnApi.applyColumnState({
          state: [
            {
              colId: "custName",
              hide: false,
              pinned: isMobile ? false : "left",
            },
            { colId: "showroomName", hide: false },
            { colId: "wg1CustStdDiscount", hide: false },
            { colId: "wg1CustSpclDiscount", hide: false },
            { colId: "criteria", hide: false },
            { colId: "wg1PromoDiscount", hide: false },
            { colId: "wg1CustCumulativeDiscount", hide: false },
            { colId: "wg2CustStdDiscount", hide: false },
            { colId: "wg2CustSpclDiscount", hide: false },
            { colId: "wg2PromoDiscount", hide: false },
            { colId: "wg2CustCumulativeDiscount", hide: false },
            { colId: "custVendRefNum", hide: false },
            { colId: "wg1VendorStdDiscount", hide: true },
            { colId: "wg1VendorSpclDiscount", hide: true },
            { colId: "wg1VendorPromoDiscount", hide: true },
            { colId: "wg1VendorCumulativeDiscount", hide: true },
            { colId: "wg2VendorStdDiscount", hide: true },
            { colId: "wg2VendorSpclDiscount", hide: true },
            { colId: "wg2VendorPromoDiscount", hide: true },
            { colId: "wg2VendorCumulativeDiscount", hide: true },
          ],
        });
      } else {
        updatedColDef[colcustindexAction].pinned = null;
        updatedColDef[colcustindexAction].headerName = "Partner";
        updatedColDef[colcustRefindexAction].headerName = "Cust Vend Ref Num";
        gridRef.current.columnApi?.applyColumnState({
          state: [
            // { colId: 'vendorName', hide: false },
            { colId: "custName", hide: false, pinned: null },
            { colId: "wg1VendorStdDiscount", hide: false },
            { colId: "wg1VendorSpclDiscount", hide: false },
            { colId: "wg1VendorPromoDiscount", hide: false },
            { colId: "wg1VendorCumulativeDiscount", hide: false },
            { colId: "wg2VendorStdDiscount", hide: false },
            { colId: "wg2VendorSpclDiscount", hide: false },
            { colId: "wg2VendorPromoDiscount", hide: false },
            { colId: "wg2VendorCumulativeDiscount", hide: false },
            { colId: "custVendRefNum", hide: true },
            { colId: "showroomName", hide: false },
            { colId: "wg1CustStdDiscount", hide: true },
            { colId: "wg1CustSpclDiscount", hide: true },
            { colId: "wg1PromoDiscount", hide: true },
            { colId: "wg1CustCumulativeDiscount", hide: true },
            { colId: "wg2CustStdDiscount", hide: true },
            { colId: "wg2CustSpclDiscount", hide: true },
            { colId: "wg2PromoDiscount", hide: true },
            { colId: "wg2CustCumulativeDiscount", hide: true },
          ],
        });
      }

      setColumnDefs(updatedColDef);
      syncPinnedColumns(discountType);
      gridRef.current.api.refreshCells();
    },
    [discountType],
  );

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
    setEditId("");
  };

  const onRowDoubleClicked = (params) => {
    // setFormOpen(true)
    if (selectedRows.length > 0 && selectedRows[0].id) {
      setEditId(selectedRows[0].id);
    }
  };

  const handleSaveAndApproveDiscount = async () => {
    props?.handleSaveClose();

    try {
      if (!selectedRows || selectedRows.length === 0) {
        setError("Please select at least one row");
        return;
      }

      const isMD = token?.scope?.includes("ROLE_MD");

      const prepareDiscountRow = (row) => {
        const data = { ...row };

        if (data.vendorShortKey) {
          data.vendorName = data.vendorShortKey;
        }

        if (data.priceGroupNames) {
          data.priceGrpNames = data.priceGroupNames;
        }

        if (
          data.wg1PromoDiscount !== undefined &&
          data.wg1PromoDiscount !== null
        ) {
          data.wg1CustPromoDiscount = data.wg1PromoDiscount;
        }

        if (
          data.wg2PromoDiscount !== undefined &&
          data.wg2PromoDiscount !== null
        ) {
          data.wg2CustPromoDiscount = data.wg2PromoDiscount;
        }

        if (data.id) {
          data.discountId = data.id;
        }

        if (data.criteria && data.criteria !== "ALL") {
          data.promoDiscCriteria = data.criteria
            .replace(/\s+/g, "")
            .toUpperCase();
        }

        if (data.approvalStatus === "APPROVED") {
          data.approvalStatus = isMD ? "APPROVED" : "PENDING_APPROVAL";
        }

        delete data.criteria;
        delete data.priceGroupNames;
        delete data.vendorShortKey;
        delete data.wg1PromoDiscount;
        delete data.wg2PromoDiscount;
        delete data.id;
        delete data.products;
        delete data.productNames;
        delete data.createdDate;
        delete data.approvedDttm;
        delete data.approverId;
        delete data.createdByUser;
        delete data.deleted;
        delete data.lastModifiedDate;
        delete data.modifiedByUser;
        delete data.version;
        delete data.wg1CustCumulativeDiscount;
        delete data.wg2CustCumulativeDiscount;
        delete data.wg1VendorCumulativeDiscount;
        delete data.wg2VendorCumulativeDiscount;

        return data;
      };

      const validateCustomerRow = (row) => {
        const baseValid =
          row.custName &&
          row.vendorName &&
          row.fromQty !== "" &&
          row.fromQty >= 0 &&
          row.toQty !== "" &&
          row.toQty >= 0 &&
          row.slabNum >= 0 &&
          row.orderCategoryName &&
          row.custVendRefNum &&
          row.wg1CustStdDiscount >= 0 &&
          row.wg2CustStdDiscount >= 0;

        if (!baseValid) return false;

        if (row.enablePromoDisc) {
          return (
            (row.wg1CustPromoDiscount >= 0 || row.wg2CustPromoDiscount >= 0) &&
            row.orderType
          );
        }

        return true;
      };

      const validateVendorRow = (row) => {
        const baseValid =
          row.vendorName &&
          row.fromQty !== "" &&
          row.fromQty >= 0 &&
          row.toQty !== "" &&
          row.toQty >= 0 &&
          row.slabNum >= 0 &&
          row.orderCategoryName &&
          row.wg1VendorStdDiscount >= 0 &&
          row.wg2VendorStdDiscount >= 0;

        if (!baseValid) return false;

        if (row.enableVendorPromoDisc) {
          return (
            (row.wg1VendorPromoDiscount >= 0 ||
              row.wg2VendorPromoDiscount >= 0) &&
            row.orderType
          );
        }

        return true;
      };

      const buildCustomerApprovalPayload = (createdDiscounts) => {
        return createdDiscounts.map((d) => ({
          orderCategoryName: d.orderCategoryName,
          fromQty: d.fromQty,
          toQty: d.toQty,
          slabNum: d.slabNum,
          paymentTerm: d.paymentTerm || null,
          vendorNum: d.vendorNum,
          vendorName: d.vendorName,
          approvalStatus: d.approvalStatus,
          validFrom: d.validFrom,
          validTo: d.validTo,
          custNum: d.custNum,
          custName: d.custName,
          custVendRefNum: d.custVendRefNum,
          showroomNum: d.showroomNum || null,
          showroomName: d.showroomName,
          wg1CustStdDiscount: d.wg1CustStdDiscount,
          wg1CustSpclDiscount: d.wg1CustSpclDiscount,
          wg2CustStdDiscount: d.wg2CustStdDiscount,
          wg2CustSpclDiscount: d.wg2CustSpclDiscount,
          active: d.active,
          wg1VendorPromoDiscount: d.wg1VendorPromoDiscount || 0,
          wg2VendorPromoDiscount: d.wg2VendorPromoDiscount || 0,
          discountId: d.id,
        }));
      };

      const buildVendorApprovalPayload = (createdDiscounts) => {
        return createdDiscounts.reduce((acc, d) => {
          const key = d.vendorNum;

          if (!acc[key]) {
            acc[key] = [];
          }

          acc[key].push({
            orderCategoryName: d.orderCategoryName,
            fromQty: d.fromQty,
            toQty: d.toQty,
            slabNum: d.slabNum,
            paymentTerm: d.paymentTerm || "",
            vendorNum: d.vendorNum,
            vendorName: d.vendorName,
            approvalStatus: d.approvalStatus,
            validFrom: d.validFrom,
            validTo: d.validTo,
            custNum: d.custNum,
            custName: d.custName,
            custVendRefNum: d.custVendRefNum,
            wg1VendorStdDiscount: d.wg1VendorStdDiscount,
            wg1VendorSpclDiscount: d.wg1VendorSpclDiscount,
            wg2VendorStdDiscount: d.wg2VendorStdDiscount,
            wg2VendorSpclDiscount: d.wg2VendorSpclDiscount,
            active: d.active,
            wg1VendorPromoDiscount: d.wg1VendorPromoDiscount || 0,
            wg2VendorPromoDiscount: d.wg2VendorPromoDiscount || 0,
            discountId: d.id,
          });

          return acc;
        }, {});
      };

      const preparedDiscounts = selectedRows.map((row) =>
        prepareDiscountRow(row),
      );
      const createdDiscounts = [];
      const cleanPayload = (data) => {
        const payload = { ...data };

        if (payload.orderType === "ALL") {
          delete payload.orderType;
        }

        if (payload.promoDiscCriteria === "ALL") {
          delete payload.promoDiscCriteria;
        }

        return payload;
      };
      for (let i = 0; i < preparedDiscounts.length; i++) {
        const discount = preparedDiscounts[i];

        if (discountType === "Customer") {
          const valid = validateCustomerRow(discount);

          if (!valid) {
            setError(
              `Please fill up all required fields in selected row ${i + 1}`,
            );
            return;
          }
          const payload = cleanPayload(discount);
          const response = await OAuthService.addData(
            url + "/createNewDiscount",
            payload,
          );

          if (response?.data) {
            createdDiscounts.push(response.data);
          }
        } else {
          const valid = validateVendorRow(discount);

          if (!valid) {
            setError(
              `Please fill up all required fields in selected row ${i + 1}`,
            );
            return;
          }
          const payload = cleanPayload(discount);
          const response = await OAuthService.addData(
            url + "/createnewvendordiscount",
            payload,
          );

          if (response?.data) {
            createdDiscounts.push(response.data);
          }
        }
      }

      if (createdDiscounts.length === 0) {
        setError("No discounts were created");
        return;
      }

      if (discountType === "Customer") {
        const approvalPayload = buildCustomerApprovalPayload(createdDiscounts);

        await OAuthService.putData(
          url + "/sendDiscountsForApproval",
          approvalPayload,
        );
      } else {
        const approvalPayload = buildVendorApprovalPayload(createdDiscounts);

        await OAuthService.putData(
          url + "/sendVendorsDiscountsForApproval",
          approvalPayload,
        );
      }

      setSuccessMsg(
        createdDiscounts.length === 1
          ? "Discount saved and sent for approval."
          : `${createdDiscounts.length} discounts saved and sent for approval.`,
      );
      setSnackState(true);
      setError("");
      loadDiscounts();
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const handleSaveDiscount = async () => {
    props?.handleSaveClose();

    try {
      if (!selectedRows || selectedRows.length === 0) {
        setError("Please select at least one row");
        return;
      }

      const isMD = token?.scope?.includes("ROLE_MD");

      const prepareDiscountRow = (row) => {
        const data = { ...row };

        if (data.vendorShortKey) {
          data.vendorName = data.vendorShortKey;
        }

        if (data.priceGroupNames) {
          data.priceGrpNames = data.priceGroupNames;
        }

        if (
          data.wg1PromoDiscount !== undefined &&
          data.wg1PromoDiscount !== null
        ) {
          data.wg1CustPromoDiscount = data.wg1PromoDiscount;
        }

        if (
          data.wg2PromoDiscount !== undefined &&
          data.wg2PromoDiscount !== null
        ) {
          data.wg2CustPromoDiscount = data.wg2PromoDiscount;
        }

        if (data.id) {
          data.discountId = data.id;
        }

        if (data.criteria && data.criteria !== "ALL") {
          data.promoDiscCriteria = data.criteria
            .replace(/\s+/g, "")
            .toUpperCase();
        }

        if (data.approvalStatus === "APPROVED") {
          data.approvalStatus = isMD ? "APPROVED" : "PENDING_APPROVAL";
        } else if (
          data.approvalStatus === "PENDING_APPROVAL" ||
          data.approvalStatus === "REJECTED"
        ) {
          data.approvalStatus = isMD ? "APPROVED" : "PENDING_APPROVAL";
        } else if (data.approvalStatus === "NEW") {
          data.approvalStatus = isMD ? "APPROVED" : "NEW";
        }

        delete data.criteria;
        delete data.priceGroupNames;
        delete data.vendorShortKey;
        delete data.wg1PromoDiscount;
        delete data.wg2PromoDiscount;
        delete data.id;
        delete data.products;
        delete data.productNames;
        delete data.createdDate;
        delete data.approvedDttm;
        delete data.approverId;
        delete data.createdByUser;
        delete data.deleted;
        delete data.lastModifiedDate;
        delete data.modifiedByUser;
        delete data.version;
        delete data.wg1CustCumulativeDiscount;
        delete data.wg2CustCumulativeDiscount;
        delete data.wg1VendorCumulativeDiscount;
        delete data.wg2VendorCumulativeDiscount;

        return data;
      };

      const isUpdateRow = (row) => !!(row.id || row.discountId);

      const validateCustomerRow = (row, isUpdate) => {
        const baseValid =
          row.custName &&
          (isUpdate ? row.vendorNum : row.vendorName) &&
          row.fromQty !== "" &&
          row.fromQty >= 0 &&
          row.toQty !== "" &&
          row.toQty >= 0 &&
          row.slabNum >= 0 &&
          row.orderCategoryName &&
          row.custVendRefNum &&
          row.wg1CustStdDiscount >= 0 &&
          row.wg2CustStdDiscount >= 0;

        if (!baseValid) return false;

        if (row.enablePromoDisc) {
          return (
            (row.wg1CustPromoDiscount >= 0 || row.wg2CustPromoDiscount >= 0) &&
            (isUpdate
              ? row.orderType !== undefined ||
                row.promoDiscCriteria !== undefined
              : row.orderType)
          );
        }

        return true;
      };

      const validateVendorRow = (row, isUpdate) => {
        const baseValid =
          (isUpdate ? row.vendorNum : row.vendorName) &&
          row.fromQty !== "" &&
          row.fromQty >= 0 &&
          row.toQty !== "" &&
          row.toQty >= 0 &&
          row.slabNum >= 0 &&
          row.orderCategoryName &&
          row.wg1VendorStdDiscount >= 0 &&
          row.wg2VendorStdDiscount >= 0;

        if (!baseValid) return false;

        if (row.enableVendorPromoDisc) {
          return (
            (row.wg1VendorPromoDiscount >= 0 ||
              row.wg2VendorPromoDiscount >= 0) &&
            (isUpdate
              ? row.orderType !== undefined ||
                row.promoDiscCriteria !== undefined
              : row.orderType)
          );
        }

        return true;
      };

      const preparedDiscounts = selectedRows.map((row) =>
        prepareDiscountRow(row),
      );
      const cleanPayload = (data) => {
        const payload = { ...data };

        if (payload.orderType === "ALL") {
          delete payload.orderType;
        }

        if (payload.promoDiscCriteria === "ALL") {
          delete payload.promoDiscCriteria;
        }

        return payload;
      };
      for (let i = 0; i < preparedDiscounts.length; i++) {
        const discount = preparedDiscounts[i];
        const originalRow = selectedRows[i];
        const isUpdate = isUpdateRow(originalRow);

        if (discountType === "Customer") {
          const valid = validateCustomerRow(discount, isUpdate);

          if (!valid) {
            setError(
              `Please fill up all required fields in selected row ${i + 1}`,
            );
            return;
          }

          if (isUpdate) {
            const payload = cleanPayload(discount);
            await OAuthService.putData(url + "/updateDiscount", payload);
          } else {
            const payload = cleanPayload(discount);
            await OAuthService.addData(url + "/createNewDiscount", payload);
          }
        } else {
          const valid = validateVendorRow(discount, isUpdate);

          if (!valid) {
            setError(
              `Please fill up all required fields in selected row ${i + 1}`,
            );
            return;
          }

          if (isUpdate) {
            const payload = cleanPayload(discount);
            await OAuthService.putData(url + "/updateDiscount", payload);
          } else {
            const payload = cleanPayload(discount);
            await OAuthService.addData(
              url + "/createnewvendordiscount",
              payload,
            );
          }
        }
      }

      setSuccessMsg(
        preparedDiscounts.length === 1
          ? "Discount saved successfully."
          : `${preparedDiscounts.length} discounts saved successfully.`,
      );
      setSnackState(true);
      setError("");
      loadDiscounts();
      setUpdateData([]);
      setAddRowData([]);
      setSelectedRows([]);
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const onBtAdd = useCallback(
    (event) => {
      setEdit(true);
      const newRow = {
        productIds: [],
        productNames: "",
        orderCategoryName: "",
        priceGroupNames: "",
        fromQty: "",
        toQty: "",
        slabNum: "",
        custNum: props.customerId ? props.customerId : "",
        custName: props.customerName ? props.customerName : "",
        custVendRefNum: "",
        showroomNum: 0,
        showroomName: "",
        vendorNum: props.vendorId ? props.vendorId : 0,
        vendorName: props.vendorName ? props.vendorName : "",
        paymentTerm: "",
        wg1CustStdDiscount: "",
        wg1CustSpclDiscount: "",
        wg2CustStdDiscount: "",
        wg2CustSpclDiscount: "",
        wg1VendorStdDiscount: "",
        wg1VendorSpclDiscount: "",
        wg2VendorStdDiscount: "",
        wg2VendorSpclDiscount: "",
        enablePromoDisc: false,
        enableVendorPromoDisc: false,
        validFrom: "",
        validTo: "",
        criteria: "",
        orderType: "",
        wg1PromoDiscount: "",
        wg2PromoDiscount: "",
        wg1VendorPromoDiscount: "",
        wg2VendorPromoDiscount: "",
        approvalStatus: "NEW",
        active: true,
      };
      // const RowIndex = event.node.rowIndex + 1;
      let index =
        rowData.findIndex((row) => row.id === event?.node?.data?.id) || 0;
      const nextIndex = index + 1;
      rowData.splice(nextIndex, 0, newRow);
      const correctRowIndex = gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: nextIndex,
      });

      gridRef.current.api.refreshCells();

      setAddRowData((prev) => [...prev, newRow]);
      setTimeout(() => {
        gridRef.current.api.setFocusedCell(
          correctRowIndex.add[0].rowIndex,
          "vendorName",
        );
        gridRef.current.api.startEditingCell({
          rowIndex: correctRowIndex.add[0].rowIndex,
          colKey: "vendorName",
        });
      }, 800);
    },
    [rowData],
  );

  const handleRequestApprovalDiscount = async () => {
    const discountData = JSON.parse(JSON.stringify([...selectedRows]));
    const discounts = discountData.map((data) => {
      if (data.priceGroupNames) {
        data.priceGrpNames = data.priceGroupNames;
      }
      if (data.wg1PromoDiscount) {
        data.wg1CustPromoDiscount = data.wg1PromoDiscount;
      }
      if (data.wg2PromoDiscount) {
        data.wg2CustPromoDiscount = data.wg2PromoDiscount;
      }
      if (data.id) {
        data.discountId = data.id;
      }
      if (data.criteria && data.criteria !== "ALL") {
        data.promoDiscCriteria = data.criteria
          .replace(/\s+/g, "")
          .toUpperCase();
      }
      delete data.criteria;
      delete data.priceGroupNames;
      delete data.wg1PromoDiscount;
      delete data.wg2PromoDiscount;
      delete data.id;
      delete data.products;
      delete data.productNames;
      delete data.createdDate;
      delete data.approvedDttm;
      delete data.approverId;
      delete data.createdByUser;
      delete data.deleted;
      delete data.lastModifiedDate;
      delete data.modifiedByUser;
      delete data.requestedBy;
      delete data.requestedDate;
      delete data.version;
      delete data.wg1CustCumulativeDiscount;
      delete data.wg2CustCumulativeDiscount;
      delete data.wg1VendorCumulativeDiscount;
      delete data.wg2VendorCumulativeDiscount;

      return data;
    });
    if (discountType === "Customer") {
      try {
        await OAuthService.putData(
          url + "/sendDiscountsForApproval",
          discounts,
        );
        setSuccessMsg("Discount send for approval.");
        setSnackState(true);
        loadDiscounts();
        setError("");
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    } else {
      try {
        await OAuthService.putData(url + "/sendVendorsDiscountsForApproval", {
          [discounts[0].vendorNum]: discounts,
        });
        setSuccessMsg("Discount send for approval.");
        setSnackState(true);
        loadDiscounts();
        setError("");
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };
  const handleSubmitApprovalDiscount = async () => {
    const discountData = JSON.parse(JSON.stringify([...selectedRows]));
    const discounts = discountData.map((data) => {
      if (data.priceGroupNames) {
        data.priceGrpNames = data.priceGroupNames;
      }
      if (data.wg1PromoDiscount) {
        data.wg1CustPromoDiscount = data.wg1PromoDiscount;
      }
      if (data.wg2PromoDiscount) {
        data.wg2CustPromoDiscount = data.wg2PromoDiscount;
      }
      if (data.id) {
        data.discountId = data.id;
      }
      if (data.criteria && data.criteria !== "ALL") {
        data.promoDiscCriteria = data.criteria
          .replace(/\s+/g, "")
          .toUpperCase();
      }
      delete data.criteria;
      delete data.priceGroupNames;
      delete data.wg1PromoDiscount;
      delete data.wg2PromoDiscount;
      delete data.id;
      delete data.products;
      delete data.productNames;
      delete data.createdDate;
      delete data.approvedDttm;
      delete data.approverId;
      delete data.createdByUser;
      delete data.deleted;
      delete data.lastModifiedDate;
      delete data.modifiedByUser;
      delete data.version;
      delete data.wg1CustCumulativeDiscount;
      delete data.wg2CustCumulativeDiscount;
      delete data.wg1VendorCumulativeDiscount;
      delete data.wg2VendorCumulativeDiscount;

      return data;
    });
    if (discountType === "Customer") {
      try {
        await OAuthService.putData(
          url + "/approveOrRejectDiscounts/true",
          discounts,
        );
        setSuccessMsg("Discount Approved.");
        setSnackState(true);
        loadDiscounts();
        setError("");
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    } else {
      try {
        await OAuthService.putData(
          url + "/approveOrRejectVendorsDiscounts/true",
          { [discounts[0].vendorNum]: discounts },
        );
        setSuccessMsg("Discount Approved.");
        setSnackState(true);
        loadDiscounts();
        setError("");
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };
  const handleSubmitDeclineDiscount = async () => {
    const discountData = JSON.parse(JSON.stringify([...selectedRows]));
    const discounts = discountData.map((data) => {
      if (data.priceGroupNames) {
        data.priceGrpNames = data.priceGroupNames;
      }
      if (data.wg1PromoDiscount) {
        data.wg1CustPromoDiscount = data.wg1PromoDiscount;
      }
      if (data.wg2PromoDiscount) {
        data.wg2CustPromoDiscount = data.wg2PromoDiscount;
      }
      if (data.id) {
        data.discountId = data.id;
      }
      if (data.criteria && data.criteria !== "ALL") {
        data.promoDiscCriteria = data.criteria
          .replace(/\s+/g, "")
          .toUpperCase();
      }
      delete data.criteria;
      delete data.priceGroupNames;
      delete data.wg1PromoDiscount;
      delete data.wg2PromoDiscount;
      delete data.id;
      delete data.products;
      delete data.productNames;
      delete data.createdDate;
      delete data.approvedDttm;
      delete data.approverId;
      delete data.createdByUser;
      delete data.deleted;
      delete data.lastModifiedDate;
      delete data.modifiedByUser;
      delete data.version;
      delete data.wg1CustCumulativeDiscount;
      delete data.wg2CustCumulativeDiscount;
      delete data.wg1VendorCumulativeDiscount;
      delete data.wg2VendorCumulativeDiscount;

      return data;
    });
    if (discountType === "Customer") {
      try {
        await OAuthService.putData(
          url + "/approveOrRejectDiscounts/false",
          discounts,
        );
        setSuccessMsg("Discount Rejected.");
        setSnackState(true);
        loadDiscounts();
        setError("");
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    } else {
      try {
        await OAuthService.putData(
          url + "/approveOrRejectVendorsDiscounts/false",
          { [discounts[0].vendorNum]: discounts },
        );
        setSuccessMsg("Discount Rejected.");
        setSnackState(true);
        loadDiscounts();
        setError("");
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };

  useEffect(() => {
    const loadInitial = async () => {
      // Load Privileges
      const arg = "ROLE_";
      const roles = token?.scope.filter((value) => value.startsWith(arg));

      await Promise.all(
        roles.map(async (roleName) => {
          const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/privilegesByRole?roleName=${roleName}`;
          const resp = await OAuthService.getList(url);

          resp?.data?.result?.forEach((role) => {
            if (role.id === "PRIVILEGE_REQDISC")
              setPriRequest((prev) => [...prev, role]);
            if (role.id === "PRIVILEGE_APPDISC")
              setPriApprove((prev) => [...prev, role]);
            if (role.id === "PRIVILEGE_VIDISC")
              setPriView((prev) => [...prev, role]);
            if (role.id === "PRIVILEGE_UPDDISC")
              setPriUpdate((prev) => [...prev, role]);
          });
        }),
      );

      // Load partners
      const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}?size=1000`;
      const partnersResp = await OAuthService.getList(companyUrl);
      const list = [];
      partnersResp?.data?._embedded?.companies?.map((c) => {
        list[c.id] = c.shortKey + " - " + c.countryCode;
      });
      setPartnerList(list);

      // Load products
      // const productsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
      // const prodResp = await OAuthService.addData(productsUrl, { materialStatus: "true" });
      const findAllRangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
      const rangeList = await OAuthService.getList(findAllRangeUrl);
      const productsurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.handles}`;
      const products = await OAuthService.getList(
        productsurl + `/search/findAllHandles`,
      );
      let range = [];
      let handle = [];
      // prodResp?.data?.map(p => {
      //     if (p._class === "Handle") handle[p.id] = p.productName;
      //     if (p._class === "Range") range[p.id] = p.productName;
      // });
      rangeList.data.map((p) => (range[p.id] = p.productName));
      setRangeList(range);
      products?.data?._embedded?.handles.map(
        (p) => (handle[p.id] = p.productName),
      );
      setHandleList(handle);

      // Mark initial load complete
      setInitialLoaded(true);
    };

    loadInitial();
  }, []);

  const onBtAddChild = useCallback(
    (event) => {
      setEdit(true);

      const newRow = {
        productIds: [],
        productNames: "",
        orderCategoryName: event.node.data.orderCategoryName,
        priceGroupNames: "",
        fromQty: event.node.data.fromQty,
        toQty: event.node.data.toQty,
        slabNum: event.node.data.slabNum,
        custNum: event.node.data.custNum,
        custName: event.node.data.custName,
        custVendRefNum: event.node.data.custVendRefNum,
        showroomNum: 0,
        showroomName: "",
        vendorNum: event.node.data.vendorNum,
        vendorName: event.node.data.vendorName,
        paymentTerm: event.node.data.paymentTerm,
        wg1CustStdDiscount: event.node.data.wg1CustStdDiscount,
        wg1CustSpclDiscount: event.node.data.wg1CustSpclDiscount,
        wg2CustStdDiscount: event.node.data.wg2CustStdDiscount,
        wg2CustSpclDiscount: event.node.data.wg2CustSpclDiscount,
        wg1VendorStdDiscount: event.node.data.wg1VendorStdDiscount,
        wg1VendorSpclDiscount: event.node.data.wg1VendorSpclDiscount,
        wg2VendorStdDiscount: event.node.data.wg2VendorStdDiscount,
        wg2VendorSpclDiscount: event.node.data.wg2VendorSpclDiscount,
        wg1CustCumulativeDiscount: event.node.data.wg1CustCumulativeDiscount,
        wg2CustCumulativeDiscount: event.node.data.wg2CustCumulativeDiscount,
        wg1VendorCumulativeDiscount:
          event.node.data.wg1VendorCumulativeDiscount,
        wg2VendorCumulativeDiscount:
          event.node.data.wg2VendorCumulativeDiscount,
        wg1VendorPromoDiscount: "",
        wg2VendorPromoDiscount: "",
        enablePromoDisc: discountType === "Customer" && true,
        enableVendorPromoDisc: discountType === "Vendor" && true,
        criteria: "",
        dateType: "",
        validFrom: "",
        validTo: event.node.data.validTo,
        orderType: "",
        wg1PromoDiscount: "",
        wg2PromoDiscount: "",
        approvalStatus: "NEW",

        active: event.node.data.active,
      };
      const RowIndex = event.node.rowIndex + 1;
      let index = rowData.findIndex((row) => row.id === event.node.data.id);
      const nextIndex = index + 1;
      rowData.splice(nextIndex, 0, newRow);
      const correctRowIndex = gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: nextIndex,
      });
      gridRef.current.api.refreshCells();
      // const data = [...addRowData, newRow];
      // setAddRowData(data);
      setAddRowData((prev) => [...prev, newRow]);
      setTimeout(() => {
        gridRef.current.api.setFocusedCell(
          correctRowIndex.add[0].rowIndex,
          "vendorName",
        );
        gridRef.current.api.startEditingCell({
          rowIndex: correctRowIndex.add[0].rowIndex,
          colKey: "vendorName",
        });
      }, 800);
    },
    [rowData],
  );

  const onBtStartEditing = useCallback(
    (event) => {
      if (!gridRef?.current?.api) return;

      const api = gridRef.current.api;

      setEdit(true);

      const selectedRows = api.getSelectedRows();

      const rowsToEdit =
        selectedRows && selectedRows.length > 0
          ? selectedRows
          : event?.node?.data
          ? [event.node.data]
          : [];

      if (!rowsToEdit.length) return;

      // Mark rows as editable
      const updatedRows = rowsToEdit.map((row) => ({
        ...row,
        isEditable: true,
      }));

      // Update grid rows
      api.applyTransaction({
        update: updatedRows,
      });

      // Refresh cells so editable condition re-evaluates
      api.refreshCells({ force: true });

      // Focus first row only (AgGrid limitation)
      const firstRowNode = api.getDisplayedRowAtIndex(
        event?.node?.rowIndex ?? 0,
      );

      setTimeout(() => {
        if (firstRowNode) {
          api.setFocusedCell(firstRowNode.rowIndex, "vendorName");
          api.startEditingCell({
            rowIndex: firstRowNode.rowIndex,
            colKey: "vendorName",
          });
        }
      }, 300);
    },
    [gridRef],
  );

  const onBtCopyRow = useCallback(
    (event) => {
      if (!gridRef?.current?.api) return;

      setEdit(true);

      const api = gridRef.current.api;
      const selectedRows = api.getSelectedRows();

      // fallback: if no rows are selected, copy the right-clicked row
      const rowsToCopy =
        selectedRows && selectedRows.length > 0
          ? selectedRows
          : event?.node?.data
          ? [event.node.data]
          : [];

      if (!rowsToCopy.length) return;

      // find insertion position based on clicked row
      const clickedRowId = event?.node?.data?.id;
      const clickedIndex = rowData.findIndex((row) => row.id === clickedRowId);
      const insertIndex = rowData.length;

      const copiedRows = rowsToCopy.map((data) => ({
        productIds: data.productIds,
        productNames: data.productNames,
        orderCategoryName: data.orderCategoryName,
        priceGroupNames: data.priceGroupNames,
        fromQty: data.fromQty,
        toQty: data.toQty,
        slabNum: data.slabNum,
        custNum: data.custNum,
        custName: data.custName,
        custVendRefNum: data.custVendRefNum,
        showroomNum: data.showroomNum,
        showroomName: data.showroomName,
        vendorNum: data.vendorNum,
        vendorName: data.vendorName,
        paymentTerm: data.paymentTerm,
        wg1CustStdDiscount: data.wg1CustStdDiscount,
        wg1CustSpclDiscount: data.wg1CustSpclDiscount,
        wg1CustCumulativeDiscount: data.wg1CustCumulativeDiscount,
        wg2CustStdDiscount: data.wg2CustStdDiscount,
        wg2CustSpclDiscount: data.wg2CustSpclDiscount,
        wg2CustCumulativeDiscount: data.wg2CustCumulativeDiscount,
        wg1VendorStdDiscount: data.wg1VendorStdDiscount,
        wg1VendorSpclDiscount: data.wg1VendorSpclDiscount,
        wg1VendorCumulativeDiscount: data.wg1VendorCumulativeDiscount,
        wg2VendorStdDiscount: data.wg2VendorStdDiscount,
        wg2VendorSpclDiscount: data.wg2VendorSpclDiscount,
        wg2VendorCumulativeDiscount: data.wg2VendorCumulativeDiscount,
        enablePromoDisc: data.enablePromoDisc,
        enableVendorPromoDisc: data.enableVendorPromoDisc,
        validFrom: data.validFrom,
        validTo: data.validTo,
        orderType: data.orderType,
        wg1PromoDiscount: data.wg1PromoDiscount,
        wg2PromoDiscount: data.wg2PromoDiscount,
        wg1VendorPromoDiscount: data.wg1VendorPromoDiscount,
        wg2VendorPromoDiscount: data.wg2VendorPromoDiscount,
        criteria: data.criteria,
        dateType: data.dateType,
        approvalStatus: "NEW",
        active: data.active,
      }));

      const updatedRowData = [...rowData];
      updatedRowData.splice(insertIndex, 0, ...copiedRows);

      api.applyTransaction({
        add: copiedRows,
        addIndex: insertIndex,
      });

      api.refreshCells();

      setAddRowData((prev) => [...prev, ...copiedRows]);

      setTimeout(() => {
        api.setFocusedCell(insertIndex, "vendorName");
        api.startEditingCell({
          rowIndex: insertIndex,
          colKey: "vendorName",
        });
      }, 300);
    },
    [rowData, gridRef, setEdit, setAddRowData],
  );
  const warningShown = useRef(false);

  const processCellFromClipboard = useCallback(
    (params) => {
      const colId = params.column.getColId();

      // Partner
      if (colId === "custName") {
        const pastedValue = params.value?.toString().trim().toUpperCase();

        const customer = customerOptions.find((c) => {
          const parts = c.label
            .toUpperCase()
            .split("-")
            .map((s) => s.trim());

          return (
            c.label.toUpperCase() === pastedValue || parts.includes(pastedValue)
          );
        });

        if (!customer) {
          if (!warningShown.current) {
            toast.warning("No matching partner found with copied value");
            warningShown.current = true;

            setTimeout(() => {
              warningShown.current = false;
            }, 500);
          }

          params.node.setDataValue("custNum", "");

          return "";
        }

        params.node.setDataValue("custNum", customer.id);

        return customer.label;
      }

      if (colId === "orderCategoryName") {
        const pastedValue = params.value?.toString().trim().toUpperCase();

        const orderCategory = orderCategoryOptions.find(
          (o) =>
            o.value.toUpperCase() === pastedValue ||
            o.name.toUpperCase() === pastedValue,
        );

        if (!orderCategory) {
          if (!warningShown.current) {
            toast.warning("No matching order category found with copied value");
            warningShown.current = true;

            setTimeout(() => {
              warningShown.current = false;
            }, 500);
          }

          return "";
        }

        return orderCategory.value;
      }
      if (colId === "showroomName") {
        const pastedValue = params.value?.toString().trim().toUpperCase();

        const custId = params.node.data?.custNum;

        const availableShowrooms =
          (custId && showroomMap?.[custId]?.length
            ? showroomMap[custId]
            : allShowrooms) || [];

        const matched = availableShowrooms.find((s) => {
          const label = (s.label || "").toUpperCase();
          const name = (s.name || "").toUpperCase();

          const idMatch = String(s.id) === pastedValue;

          const labelMatch =
            label === pastedValue ||
            label.includes(pastedValue) ||
            label.split("-")[0]?.trim() === pastedValue;

          const nameMatch = name === pastedValue;

          return idMatch || labelMatch || nameMatch;
        });

        if (!matched) {
          if (!warningShown.current) {
            toast.warning("No matching showroom found with copied value");
            warningShown.current = true;

            setTimeout(() => {
              warningShown.current = false;
            }, 500);
          }

          params.node.setDataValue("showroomNum", "");
          params.node.setDataValue("showroomName", "");

          return "";
        }

        params.node.setDataValue("showroomNum", matched.id);

        return matched.label;
      }
      return params.value;
    },
    [customerOptions, orderCategoryOptions],
  );
  const onBtDeleteRow = useCallback(
    async (event) => {
      try {
        const api = gridRef?.current?.api;
        if (!api) return;

        const clickedRow = event?.node?.data;
        const selectedRowsFromGrid = api.getSelectedRows() || [];

        const rowsToDelete =
          selectedRowsFromGrid.length > 0
            ? selectedRowsFromGrid
            : clickedRow
            ? [clickedRow]
            : [];

        if (!rowsToDelete.length) {
          setError("Please select at least one row");
          return;
        }

        const isIAMOnly =
          token?.scope?.includes("ROLE_IAM") &&
          !token?.scope?.includes("ROLE_ADMIN") &&
          !token?.scope?.includes("ROLE_SOPDIR");

        const blockedRows = [];
        const apiRowsToDelete = [];
        const localRowsToDelete = [];

        for (const row of rowsToDelete) {
          if (!row?.id) {
            localRowsToDelete.push(row);
            continue;
          }

          if (isIAMOnly && row.approvalStatus !== "NEW") {
            blockedRows.push(row);
            continue;
          }

          apiRowsToDelete.push(row);
        }

        if (blockedRows.length > 0) {
          setError(
            blockedRows.length === 1
              ? "Access denied for 1 selected row"
              : `Access denied for ${blockedRows.length} selected rows`,
          );
        } else {
          setError("");
        }

        for (const row of apiRowsToDelete) {
          await OAuthService.deleteData(url + "/deleteDiscount", row.id);
        }

        const rowsRemovedFromGrid = [...apiRowsToDelete, ...localRowsToDelete];

        if (rowsRemovedFromGrid.length > 0) {
          api.applyTransaction({ remove: rowsRemovedFromGrid });
        }

        setRowData((prev) =>
          prev.filter(
            (item) =>
              !rowsRemovedFromGrid.some(
                (deletedRow) =>
                  (deletedRow.id && item.id === deletedRow.id) ||
                  (deletedRow.tempId && item.tempId === deletedRow.tempId),
              ),
          ),
        );

        setAddRowData((prev) =>
          prev.filter(
            (item) =>
              !localRowsToDelete.some(
                (deletedRow) =>
                  (deletedRow.id && item.id === deletedRow.id) ||
                  (deletedRow.tempId && item.tempId === deletedRow.tempId),
              ),
          ),
        );

        if (rowsRemovedFromGrid.length > 0) {
          setSuccessMsg(
            rowsRemovedFromGrid.length === 1
              ? "Discount deleted successfully."
              : `${rowsRemovedFromGrid.length} discounts deleted successfully.`,
          );
          setSnackState(true);
          loadDiscounts();
        }
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    },
    [gridRef, token, url, setRowData, setAddRowData, loadDiscounts],
  );

  const getContextMenuItems = useCallback(
    (event) => {
      const discountDate =
        selectedRows.length > 0 && new Date(selectedRows[0].validTo);
      const currentDate = new Date();
      const isEmptyClick = !event.node || event.node.rowIndex == null;
      var result = [
        {
          name: "Add Discount",
          icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
          disabled: isEmptyClick
            ? false
            : token?.scope?.includes("ROLE_MD")
            ? true
            : !(
                token?.scope.includes("ROLE_IAM") ||
                token?.scope.includes("ROLE_SOPDIR") ||
                token?.scope.includes("ROLE_ADMIN")
              ) && selectedRows.length > 0
            ? true
            : false,

          action: () => {
            onBtAdd(event);
          },
        },
        {
          name: "Add Promo Discount",
          icon: '<span><i class="material-icons style="font-size: 18px">subdirectory_arrow_right</i></span>',
          disabled: isEmptyClick
            ? true
            : token?.scope?.includes("ROLE_MD")
            ? true
            : !token?.scope.includes("ROLE_MD") ||
              !token?.scope.includes("ROLE_SOPDIR") ||
              !token?.scope.include("ROLE_ADMIN")
            ? false
            : true,
          action: () => {
            onBtAddChild(event);
          },
        },
        {
          name: "Edit Discount",
          icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
          disabled: isEmptyClick
            ? true
            : token?.scope.includes("ROLE_MD") &&
              discountStatus === "PENDING_APPROVAL"
            ? true
            : !token?.scope.includes("ROLE_MD") ||
              !token?.scope.includes("ROLE_SOPDIR") ||
              !token?.scope.includes("ROLE_ADMIN")
            ? false
            : true,
          action: () => {
            onBtStartEditing(event);
          },
        },
        {
          name: "Copy Discount",
          icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
          disabled: isEmptyClick
            ? true
            : token?.scope?.includes("ROLE_MD")
            ? true
            : !token?.scope.includes("ROLE_MD") ||
              !token?.scope.includes("ROLE_SOPDIR") ||
              !token?.scope.includes("ROLE_ADMIN")
            ? false
            : true,
          action: () => {
            onBtCopyRow(event);
          },
        },
        {
          name: "Delete Discount",
          icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
          disabled: isEmptyClick
            ? true
            : token?.scope.includes("PRIVILEGE_DELETE_DISCOUNT")
            ? false
            : true,

          action: () => {
            setRowToDelete(event);
            setOpenDeleteDialog(true);
          },
        },
        "separator",
        "export",
        "chartRange",
      ];

      if (discountType === "Customer") {
        if (
          (priUpdate && priUpdate.length > 0) ||
          token?.scope.includes("PRIVILEGE_UPDDISC")
        ) {
          return result;
        }
      } else if (discountType === "Vendor") {
        if (token?.scope.includes("PRIVILEGE_UPDVENDISC")) {
          return result;
        }
      }
    },
    [discountType, selectedRows],
  );
  const recalcCumulative = (data) => {
    const calc = (std, spcl, promo) => {
      let base = ((100 - Number(std)) * (100 - Number(spcl))) / 100;
      if (promo) base = (base * (100 - Number(promo))) / 100;
      return Number(100 - base).toFixed(3);
    };

    if (
      data.wg1CustStdDiscount ||
      data.wg1CustSpclDiscount ||
      data.wg1PromoDiscount
    )
      data.wg1CustCumulativeDiscount = calc(
        data.wg1CustStdDiscount,
        data.wg1CustSpclDiscount,
        data.wg1PromoDiscount,
      );

    if (
      data.wg2CustStdDiscount ||
      data.wg2CustSpclDiscount ||
      data.wg2PromoDiscount
    )
      data.wg2CustCumulativeDiscount = calc(
        data.wg2CustStdDiscount,
        data.wg2CustSpclDiscount,
        data.wg2PromoDiscount,
      );

    if (
      data.wg1VendorStdDiscount ||
      data.wg1VendorSpclDiscount ||
      data.wg1VendorPromoDiscount
    )
      data.wg1VendorCumulativeDiscount = calc(
        data.wg1VendorStdDiscount,
        data.wg1VendorSpclDiscount,
        data.wg1VendorPromoDiscount,
      );

    if (
      data.wg2VendorStdDiscount ||
      data.wg2VendorSpclDiscount ||
      data.wg2VendorPromoDiscount
    )
      data.wg2VendorCumulativeDiscount = calc(
        data.wg2VendorStdDiscount,
        data.wg2VendorSpclDiscount,
        data.wg2VendorPromoDiscount,
      );
  };

  const trackChangedRow = (data) => {
    setUpdateData((prev) => {
      const exists = prev.some((r) => r === data || (r.id && r.id === data.id));
      return exists
        ? prev.map((r) => (r === data || (r.id && r.id === data.id) ? data : r))
        : [...prev, data];
    });
  };
  const onRowValueChanged = useCallback((event) => {
    const data = event.data;
    recalcCumulative(data);
    gridRef.current.api.refreshCells();
    trackChangedRow(data); // merge, don't replace
  }, []);
  const isCellEditable = useCallback(
    (params) => {
      const { data, colDef } = params;
      const field = colDef?.field;
      const discountDate = new Date(data.validTo);
      const currentDate = new Date();

      const columnsNoEditable = [
        "custVendRefNum",
        "custName",
        "vendorName",
        "wg1CustStdDiscount",
        "wg2CustStdDiscount",
        "wg2CustSpclDiscount",
        "wg1CustSpclDiscount",
        "wg2VendorStdDiscount",
        "wg1VendorStdDiscount",
        "wg1VendorSpclDiscount",
        "wg2VendorSpclDiscount",
      ];

      const promoColumns = [
        "wg1PromoDiscount",
        "wg2PromoDiscount",
        "criteria",
        "dateType",
        "productNames",
        "wg1VendorPromoDiscount",
        "wg2VendorPromoDiscount",
        "orderType",
        "priceGroupNames",
      ];
      //To enable the showroom selection in vendor promo discount
      if (
        field === "showroomName" &&
        discountType === "Vendor" &&
        !data?.enableVendorPromoDisc
      ) {
        return false;
      }
      const isExpiredDiscount =
        discountDate &&
        discountDate.getFullYear() < currentDate.getFullYear() &&
        data.id;

      const canEditContextFields =
        !data.enablePromoDisc &&
        !data.enableVendorPromoDisc &&
        (token?.scope?.includes("ROLE_ADMIN") ||
          token?.scope?.includes("ROLE_SOPDIR") ||
          token?.scope?.includes("ROLE_MD"));

      const isBlockedByContext =
        !canEditContextFields &&
        ((props.vendorId && field === "vendorName") ||
          (props.customerId && field === "custName"));

      const isEditableByApproval = () => {
        if (discountType === "Customer") {
          return data.approvalStatus !== "APPROVED";
        }
        return data.approvalStatus !== "APPROVED";
      };

      if (!token?.scope.includes("ROLE_MD")) {
        // IAM role
        if (
          token?.scope.includes("ROLE_IAM") &&
          !(
            token?.scope?.includes("ROLE_ADMIN") ||
            token?.scope?.includes("ROLE_SOPDIR")
          ) &&
          data.approvalStatus === "APPROVED"
        ) {
          return true;
        }

        // SOP-DIR role
        if (token?.scope.includes("ROLE_SOPDIR")) {
          if (isExpiredDiscount) return true;

          if (data.enablePromoDisc || data.enableVendorPromoDisc) {
            if (columnsNoEditable.includes(field)) {
              if (
                data.enableVendorPromoDisc &&
                (field === "custName" || field === "custVendRefNum")
              ) {
                return true;
              }
              return false;
            }

            if (isBlockedByContext) return false;
            return true;
          } else {
            if (promoColumns.includes(field)) return false;
            if (isBlockedByContext) return false;
            return true;
          }
        }

        // Non-SOPDIR --- non-MD roles
        if (isExpiredDiscount) return false;

        if (data.enablePromoDisc || data.enableVendorPromoDisc) {
          if (columnsNoEditable.includes(field)) {
            if (
              data.enableVendorPromoDisc &&
              (field === "custName" || field === "custVendRefNum")
            ) {
              return true;
            }
            return false;
          }
          if (isBlockedByContext) return false;
          return true;
        } else {
          if (promoColumns.includes(field)) return false;
          if (isBlockedByContext) return false;
          return true;
        }
      }

      // ROLE_MD
      if (data.approvalStatus !== "APPROVED") return false;
      if (isExpiredDiscount) return false;

      if (data.enablePromoDisc || data.enableVendorPromoDisc) {
        if (columnsNoEditable.includes(field)) return false;
        if (isBlockedByContext) return false;
        return true;
      } else {
        if (promoColumns.includes(field)) return false;
        if (isBlockedByContext) return false;
        return true;
      }
    },
    [props.vendorId, props.customerId, token?.scope, discountType],
  );

  const columnTypes = useMemo(() => {
    return {
      editableColumn: {
        editable: (params) => {
          return isCellEditable(params);
        },
      },
    };
  }, [selectedRows]);
  const isRowValid = (row) => {
    if (!row) return false;

    const commonValid =
      row.vendorName &&
      row.fromQty !== "" &&
      row.fromQty >= 0 &&
      row.toQty !== "" &&
      row.toQty >= 0 &&
      row.slabNum !== "" &&
      row.slabNum >= 0 &&
      row.orderCategoryName &&
      row.validFrom &&
      row.validTo;

    if (!commonValid) return false;

    if (discountType === "Customer") {
      const customerValid =
        row.custNum !== "" &&
        row.custNum != null &&
        row.custVendRefNum &&
        row.wg1CustStdDiscount !== "" &&
        row.wg1CustStdDiscount >= 0 &&
        row.wg1CustSpclDiscount !== "" &&
        row.wg1CustSpclDiscount >= 0 &&
        row.wg2CustStdDiscount !== "" &&
        row.wg2CustStdDiscount >= 0 &&
        row.wg2CustSpclDiscount !== "" &&
        row.wg2CustSpclDiscount >= 0;

      if (!customerValid) return false;

      if (row.enablePromoDisc) {
        return (
          row.wg1PromoDiscount !== "" &&
          row.wg1PromoDiscount >= 0 &&
          row.wg2PromoDiscount !== "" &&
          row.wg2PromoDiscount >= 0 &&
          row.orderType !== ""
        );
      }

      return true;
    }

    if (discountType === "Vendor") {
      const vendorValid =
        row.wg1VendorStdDiscount !== "" &&
        row.wg1VendorStdDiscount >= 0 &&
        row.wg1VendorSpclDiscount !== "" &&
        row.wg1VendorSpclDiscount >= 0 &&
        row.wg2VendorStdDiscount !== "" &&
        row.wg2VendorStdDiscount >= 0 &&
        row.wg2VendorSpclDiscount !== "" &&
        row.wg2VendorSpclDiscount >= 0;

      if (!vendorValid) return false;

      if (row.enableVendorPromoDisc) {
        return (
          row.wg1VendorPromoDiscount !== "" &&
          row.wg1VendorPromoDiscount >= 0 &&
          row.wg2VendorPromoDiscount !== "" &&
          row.wg2VendorPromoDiscount >= 0 &&
          row.orderType !== ""
        );
      }

      return true;
    }

    return false;
  };
  const onCellValueChanged = (params) => {
    if (params.oldValue === params.newValue) return;

    if (
      params.colDef.field === "custNum" ||
      params.colDef.field === "custName"
    ) {
      const allEditors = params.api.getCellEditorInstances();
      allEditors.forEach((editor) => {
        if (editor?.updateCustomerId)
          editor.updateCustomerId(params.data.custNum);
      });
      params.node.setDataValue("showroomNum", null);
      params.node.setDataValue("showroomName", "ALL");
    }

    recalcCumulative(params.data);
    params.api.refreshCells({ rowNodes: [params.node], force: true });

    if (!params.node.isSelected()) {
      params.node.setSelected(true);
    }

    trackChangedRow(params.data);
  };
  const isRowChanged = (row) => {
    if (!row.id) return true;
    return updateData.some((r) => r === row || r.id === row.id);
  };
  useEffect(() => {
    if (!selectedRows.length) {
      setSaveBtnDisable(true);
      return;
    }
    const allValid = selectedRows.every(isRowValid);
    const hasSelectedChanges = selectedRows.every(isRowChanged);
    setSaveBtnDisable(!(allValid && hasSelectedChanges));
  }, [selectedRows, updateData, addRowData, discountType, discountStatus]);
  const didMountColumns = useRef(false);
  useEffect(() => {
    if (!gridRef.current?.columnApi) return;
    syncPinnedColumns(discountType);
  }, [isMobile, discountType]);
  useEffect(() => {
    if (!gridRef.current?.api || !gridRef.current?.columnApi) return;
    if (!didMountColumns.current) {
      didMountColumns.current = true;
      return;
    }
    loadDiscountColumns(discountType);
  }, [discountType]);
  const loadDiscountColumns = (value) => {
    //To clear the filters while  search Discount Value NT-1177
    if (gridRef.current?.api) {
      gridRef.current.api.setFilterModel(null);
      gridRef.current.api.onFilterChanged();
    }
    const updatedColDef = [...columnDefs];
    let colcustindexAction = updatedColDef?.findIndex(
      (column) => column.field === "custName",
    );
    let colcustRefindexAction = updatedColDef?.findIndex(
      (column) => column.field === "custVendRefNum",
    );
    updatedColDef[colcustindexAction].cellRenderer = (params) =>
      showStatusIcon(params, value);
    let colvendindexAction = updatedColDef?.findIndex(
      (column) => column.field === "vendorName",
    );
    updatedColDef[colvendindexAction].cellRenderer = (params) =>
      showStatusIcon(params, value);
    if (value === "Customer") {
      updatedColDef[colcustindexAction].headerName = "Partner*";
      updatedColDef[colcustRefindexAction].headerName = "Cust Vend Ref Num*";
      gridRef.current.columnApi.applyColumnState({
        state: [
          { colId: "custName", hide: false, pinned: isMobile ? false : "left" },
          { colId: "showroomName", hide: false },
          { colId: "wg1CustStdDiscount", hide: false },
          { colId: "wg1CustSpclDiscount", hide: false },
          { colId: "wg1PromoDiscount", hide: false },
          { colId: "wg1CustCumulativeDiscount", hide: false },
          { colId: "wg2CustStdDiscount", hide: false },
          { colId: "wg2CustSpclDiscount", hide: false },
          { colId: "wg2PromoDiscount", hide: false },
          { colId: "wg2CustCumulativeDiscount", hide: false },
          { colId: "custVendRefNum", hide: false },
          { colId: "wg1VendorStdDiscount", hide: true },
          { colId: "wg1VendorSpclDiscount", hide: true },
          { colId: "wg1VendorCumulativeDiscount", hide: true },
          { colId: "wg1VendorPromoDiscount", hide: true },
          { colId: "wg2VendorPromoDiscount", hide: true },
          { colId: "wg2VendorStdDiscount", hide: true },
          { colId: "wg2VendorSpclDiscount", hide: true },
          { colId: "wg2VendorCumulativeDiscount", hide: true },
        ],
      });
      updatedColDef[colcustindexAction].pinned = isMobileRef.current
        ? null
        : "left";
    } else {
      updatedColDef[colcustindexAction].pinned = null;
      updatedColDef[colcustindexAction].headerName = "Partner";
      updatedColDef[colcustRefindexAction].headerName = "Cust Vend Ref Num";
      gridRef.current.columnApi.applyColumnState({
        state: [
          // { colId: 'vendorName', hide: false, },
          { colId: "custName", hide: false, pinned: null },
          { colId: "wg1VendorStdDiscount", hide: false },
          { colId: "wg1VendorSpclDiscount", hide: false },
          { colId: "wg1VendorCumulativeDiscount", hide: false },
          { colId: "wg1VendorPromoDiscount", hide: false },
          { colId: "wg2VendorPromoDiscount", hide: false },
          { colId: "wg2VendorStdDiscount", hide: false },
          { colId: "wg2VendorSpclDiscount", hide: false },
          { colId: "wg2VendorCumulativeDiscount", hide: false },
          { colId: "custVendRefNum", hide: true },
          { colId: "showroomName", hide: false },
          { colId: "wg1CustStdDiscount", hide: true },
          { colId: "wg1CustSpclDiscount", hide: true },
          { colId: "wg1PromoDiscount", hide: true },
          { colId: "wg1CustCumulativeDiscount", hide: true },
          { colId: "wg2CustStdDiscount", hide: true },
          { colId: "wg2CustSpclDiscount", hide: true },
          { colId: "wg2PromoDiscount", hide: true },
          { colId: "wg2CustCumulativeDiscount", hide: true },
        ],
      });
      gridRef.current.columnApi.applyColumnState({
        state: [
          {
            colId: "vendorName",
            pinned: isMobile ? false : "left",
            minWidth: "150",
          },
          { colId: "fromQty", pinned: isMobile ? false : "left" },
          { colId: "toQty", pinned: isMobile ? false : "left" },
        ],
        defaultState: { pinned: null },
      });
    }
    syncPinnedColumns(value);
    gridRef.current.api.refreshCells();

    setColumnDefs(updatedColDef);
    //Multiple time API call issue
    // loadDiscounts();
  };

  const handleCopyDiscount = async () => {
    props?.handleCopyClose();
    try {
      const cyear = new Date().getFullYear();
      const list = await OAuthService.addData(
        url + `/copyDiscounts/${props?.fromYear}/${props?.toYear}`,
      );
      // if(list?.data){
      setSuccessMsg("Discount Copied successfully.");
      setSnackState(true);
      // }
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };

  useImperativeHandle(ref, () => ({
    handleSaveDiscount: handleSaveDiscount,
    handleCopyDiscount: handleCopyDiscount,
    handleSaveAndApproveDiscount: handleSaveAndApproveDiscount,
    onResetColumnState: onResetColumnState,
    handleRequestApprovalDiscount: handleRequestApprovalDiscount,
    handleSubmitDeclineDiscount: handleSubmitDeclineDiscount,
    handleSubmitApprovalDiscount: handleSubmitApprovalDiscount,
    onBtExport: onBtExport,
    loadDiscountColumns: loadDiscountColumns,
    loadDiscounts: loadDiscounts,
    toggleAutoSize: toggleAutoSize,
  }));

  useEffect(() => {
    props.successMsg(successMsg);
  }, [successMsg]);

  useEffect(() => {
    props.selectedRows(selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    props.updateData(updateData);
  }, [updateData]);

  useEffect(() => {
    props.saveBtnDisable(saveBtnDisable);
  }, [saveBtnDisable]);

  useEffect(() => {
    props.error(error);
  }, [error]);

  const handleActiveClose = () => {
    setActiveOpen(false);
  };
  const handleActiveSumbit = async (data) => {
    setActiveOpen(false);
    let updateData = data;
    updateData.active = !active;
    if (updateData.vendorShortKey) {
      updateData.vendorName = updateData.vendorShortKey;
    }
    if (updateData.priceGroupNames) {
      updateData.priceGrpNames = updateData.priceGroupNames;
    }
    if (updateData.wg1PromoDiscount) {
      updateData.wg1CustPromoDiscount = updateData.wg1PromoDiscount;
    }
    if (updateData.wg2PromoDiscount) {
      updateData.wg2CustPromoDiscount = updateData.wg2PromoDiscount;
    }
    if (updateData.id) {
      updateData.discountId = updateData.id;
    }
    if (updateData.criteria && data.criteria !== "ALL") {
      updateData.promoDiscCriteria = updateData.criteria
        .replace(/\s+/g, "")
        .toUpperCase();
    }
    gridRef.current.api.refreshCells();
    delete updateData.criteria;
    delete updateData.priceGroupNames;
    delete updateData.vendorShortKey;
    delete updateData.wg1PromoDiscount;
    delete updateData.wg2PromoDiscount;
    delete updateData.id;
    delete updateData.products;
    delete updateData.productNames;
    delete updateData.createdDate;
    delete updateData.approvedDttm;
    delete updateData.approverId;
    delete updateData.createdByUser;
    delete updateData.deleted;
    delete updateData.lastModifiedDate;
    delete updateData.modifiedByUser;
    delete updateData.version;
    delete updateData.wg1CustCumulativeDiscount;
    delete updateData.wg2CustCumulativeDiscount;
    delete updateData.wg1VendorCumulativeDiscount;
    delete updateData.wg2VendorCumulativeDiscount;
    try {
      await OAuthService.putData(url + "/updateDiscount", updateData);
      setSuccessMsg("Discount Updated successfully.");
      setSnackState(true);
      loadDiscounts();
      setError("");
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const toggleAutoSize = useCallback((autoSizeMode) => {
    if (gridRef.current) {
      const allColumnIds = [];
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      });
      if (autoSizeMode) {
        gridRef.current.columnApi.autoSizeColumns(allColumnIds);
      } else {
        gridRef.current.columnApi.autoSizeColumns(allColumnIds, true);
      }
    }
  }, []);

  const onFirstDataRendered = useCallback(() => {
    if (isMobileRef.current) {
      syncPinnedColumns(discountTypeRef.current);
    }
    const allColumnIds = [];
    gridRef.current.columnApi.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef.current.columnApi.autoSizeColumns(allColumnIds, true);
  }, []);
  return (
    <>
      <AgGridTable
        rowData={rowData}
        columnDefs={columnDefs}
        // rowModelType={'infinite'}
        onGridReady={onGridReady}
        onSelectionChanged={onSelectionChanged}
        onRowDoubleClicked={onRowDoubleClicked}
        onResetColumnState={onResetColumnState}
        gridRef={gridRef}
        getContextMenuItems={getContextMenuItems}
        rowSelection={"multiple"}
        paginationNotAutoPageSize={20}
        editable={true}
        editType={"fullRow"}
        suppressClickEdit={false}
        columnTypes={columnTypes}
        pagination={props.pagination}
        cacheBlockSize={perPage}
        saveGridStateName={`discountMasterList_${discountType}`}
        onRowValueChanged={onRowValueChanged}
        onCellValueChanged={onCellValueChanged}
        onFirstDataRendered={onFirstDataRendered}
        autoHeaderHeight={true}
        wrapHeaderText={true}
        tableClassName={"discountMasterScreen"}
        context={{ customerOptions, allCustomerOptions }}
        processCellFromClipboard={processCellFromClipboard}
      />
      <DialogBox
        open={activeOpen}
        handleClose={handleActiveClose}
        handleSumbit={() => handleActiveSumbit(selectedRows[0])}
        title={!active ? "Active Discount" : "Deactive Discount"}
      />
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent id="alert-dialog-description">
          <DialogContentText>
            Are you sure you want to delete this discount?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)} autoFocus>
            No
          </Button>
          <Button
            onClick={() => {
              if (rowToDelete) {
                onBtDeleteRow(rowToDelete);
              }
              setOpenDeleteDialog(false);
              setRowToDelete(null);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default DiscountGrid;
